
function setCookie(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString();
}
function getCookie(key) {
    var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return keyValue ? keyValue[2] : null;
}
function eraseCookie(key) {
    var keyValue = getCookie(key);
    setCookie(key, keyValue, '-1');
}

const countryOffers = [
    {
        countryCodes: ["GB","AL","AD","BD","BT","GI","GL","IS","LA","LY","LI","MC","NP","MK","NO","PS","ROW","RS","CH","VA"],
        offers: [
            "- Free Delivery Over £150",
            "- £2.99 Fixed-Fee UK Postal Returns",
            "- Free In-Store Returns"
        ]
    },
    {
        countryCodes: ["EU","BG","HR","CY","CZ","DK","EE","FI","GR","HU","IE","IT","LV","LT","MT","PL","PT","RO","SK","SI","ES","SE","AT","FR","LU","DE","BE"],
        offers: [
            "- Shipped Locally from Europe",
            "- Free Delivery Over €200",
            "- Express Delivery - Guaranteed delivery within 2 days / €10",
            "- Fixed-Fee Returns from €8"
        ]
    },
    {
        countryCodes: ["NL"],
        offers: [
            "- Shipped from the Netherlands",
            "- Free Delivery Over €200",
            // "- Next Day Delivery / €12",
            "- Fixed-Fee Returns from €8"
        ]
    },
    {
        countryCodes: ["CA"],
        offers: [
            "- Free Delivery Over 300 CAD",
            "- Express Delivery - Guaranteed delivery within 6 days",
            "- Import Fees Included at Checkout"
        ]
    },
    {
        countryCodes: ["US"], 
        offers: [
            "- Shipped Locally from U.S.",
            "- No Tariff Charges",
            "- Express Delivery - Guaranteed delivery within 2 days",
            "- Standard Delivery - Guaranteed delivery within 5 days",
            "- Free Delivery Over $250"
        ]
    },
    {
        countryCodes: ["AE"], 
        offers: [
            "- Free Next Day Delivery",
            "- Free Same-Day Delivery Over 400 AED",
            "- Easy Online Returns"
        ]
    },
    {
        countryCodes: ["KW"], 
        offers: [
            "- Standard Delivery",
            "- Free Shipping",
            "- Guaranteed delivery within 5 days."
        ]
    },
    {
        countryCodes: ["SA"], 
        offers: [
            "- Standard Delivery",
            "- Free Shipping",
            "- Guaranteed delivery within 7 days."
        ]
    },
    {
        countryCodes: ["ME","DZ","AR","BN","BO", "BF","KH","CL","GQ","KE","MV","NZ","PK","PE","PY","PA","LK","SC","SN","TN","VN","VE","ZM","ZW"],
        offers: [
            "- Free Shipping Over 400 AUD",
            "- Express Delivery - Guaranteed delivery within 5 days"
        ]
    },
    {
        countryCodes: ["QA","OM","BH"], 
        offers: [
            "- Standard Delivery",
            "- Free Shipping",
            "- Guaranteed delivery within 4 days."
        ]
    },
    {
        countryCodes: ["AU"], 
        offers: [
            "- Free delivery over 400 AUD",
            "- Express Delivery - Guaranteed delivery within 3 days"
        ]
    }
];
const countriesLanguages = [
  {
    "country_code": "NL",
    "country_name": "Netherlands",
    "languages": [
      { "name": "Dutch", "code": "gl_language=nl-NL" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "German", "code": "gl_language=de-DE" }
    ]
  },
  {
    "country_code": "FR",
    "country_name": "France",
    "languages": [
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Dutch", "code": "gl_language=nl-NL" },
      { "name": "German", "code": "gl_language=de-DE" }
    ]
  },
  {
    "country_code": "LU,BE",
    "country_name": "Luxembourg, Belgium",
    "languages": [
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Dutch", "code": "gl_language=nl-NL" },
      { "name": "German", "code": "gl_language=de-DE" }
    ]
  },
  {
    "country_code": "SA,QA,KW",
    "country_name": "Saudi Arabia, Qatar, Kuwait",
    "languages": [
      { "name": "Arabic", "code": "gl_language=ar-AE" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "AE",
    "country_name": "United Arab Emirates",
    "languages": [
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Arabic", "code": "gl_language=ar-AE" }
    ]
  },
  {
    "country_code": "AT,DE",
    "country_name": "Austria, Germany",
    "languages": [
      { "name": "German", "code": "gl_language=de-DE" },
      { "name": "French", "code": "gl_language=fr-FR" },
      { "name": "English", "code": "gl_language=en-US" },
      { "name": "Dutch", "code": "gl_language=nl-NL" }
    ]
  },
  {
    "country_code": "ES",
    "country_name": "Spain",
    "languages": [
      { "name": "Spanish", "code": "gl_language=es-ES" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "IT",
    "country_name": "Italy",
    "languages": [
      { "name": "Italian", "code": "gl_language=it-IT" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "PT",
    "country_name": "Portugal",
    "languages": [
      { "name": "Portuguese", "code": "gl_language=pt-PT" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "SE",
    "country_name": "Sweden",
    "languages": [
      { "name": "Swedish", "code": "gl_language=sv-SE" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "DK",
    "country_name": "Denmark",
    "languages": [
      { "name": "Danish", "code": "gl_language=da-DK" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "NO",
    "country_name": "Norway",
    "languages": [
      { "name": "Norwegian", "code": "gl_language=nb-NO" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "FI",
    "country_name": "Finland",
    "languages": [
      { "name": "Finnish", "code": "gl_language=fi-FI" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "PL",
    "country_name": "Poland",
    "languages": [
      { "name": "Polish", "code": "gl_language=pl-PL" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "GR",
    "country_name": "Greece",
    "languages": [
      { "name": "Greek", "code": "gl_language=el-GR" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  },
  {
    "country_code": "RO",
    "country_name": "Romania",
    "languages": [
      { "name": "Romanian", "code": "gl_language=ro-RO" },
      { "name": "English", "code": "gl_language=en-US" }
    ]
  }
];
const countryCurrencyArray = [
  { "US": { "currency": "USD", "country": "United States of America" } },
  { "GB": { "currency": "GBP", "country": "United Kingdom" } },
  { "DE": { "currency": "EUR", "country": "Germany" } },
  { "NL": { "currency": "EUR", "country": "Netherlands" } },
  { "FR": { "currency": "EUR", "country": "France" } },
  { "CA": { "currency": "CAD", "country": "Canada" } },
  { "AU": { "currency": "AUD", "country": "Australia" } },
  { "AL": { "currency": "ALL", "country": "Albania" } },
  { "DZ": { "currency": "DZD", "country": "Algeria" } },
  { "AD": { "currency": "EUR", "country": "Andorra" } },
  { "AM": { "currency": "AMD", "country": "Armenia" } },
  { "AT": { "currency": "EUR", "country": "Austria" } },
  { "AZ": { "currency": "AZN", "country": "Azerbaijan" } },
  { "AR": { "currency": "AED", "country": "Argentina" } },
  { "BH": { "currency": "AED", "country": "Bahrain" } },
  { "BD": { "currency": "BDT", "country": "Bangladesh" } },
  { "BE": { "currency": "EUR", "country": "Belgium" } },
  { "BT": { "currency": "AED", "country": "Bhutan" } },
  { "BA": { "currency": "BAM", "country": "Bosnia and Herzegovina" } },
  { "BR": { "currency": "AED", "country": "Brazil" } },
  { "BN": { "currency": "BND", "country": "Brunei" } },
  { "BG": { "currency": "EUR", "country": "Bulgaria" } },
  { "BO": { "currency": "BOB", "country": "Bolivia" } },
  { "BF": { "currency": "AED", "country": "Burkina Faso" } },
  { "KH": { "currency": "KHR", "country": "Cambodia" } },
  { "CN": { "currency": "CNY", "country": "China" } },
  { "CO": { "currency": "AED", "country": "Colombia" } },
  { "HR": { "currency": "EUR", "country": "Croatia" } },
  { "CY": { "currency": "EUR", "country": "Cyprus" } },
  { "CZ": { "currency": "EUR", "country": "Czechia" } },
  { "CL": { "currency": "AED", "country": "Chile" } },
  { "DK": { "currency": "DKK", "country": "Denmark" } },
  { "DO": { "currency": "DOP", "country": "Dominican Republic" } },
  { "EE": { "currency": "EUR", "country": "Estonia" } },
  { "EG": { "currency": "EGP", "country": "Egypt" } },
  { "GQ": { "currency": "AED", "country": "Equatorial Guinea" } },
  { "FI": { "currency": "EUR", "country": "Finland" } },
  { "GE": { "currency": "AED", "country": "Georgia" } },
  { "GI": { "currency": "GBP", "country": "Gibraltar" } },
  { "GR": { "currency": "EUR", "country": "Greece" } },
  { "GL": { "currency": "DKK", "country": "Greenland" } },
  { "GH": { "currency": "AED", "country": "Ghana" } },
  { "HK": { "currency": "HKD", "country": "Hong Kong" } },
  { "HU": { "currency": "EUR", "country": "Hungary" } },
  { "IS": { "currency": "ISK", "country": "Iceland" } },
  { "IN": { "currency": "INR", "country": "India" } },
  { "ID": { "currency": "IDR", "country": "Indonesia" } },
  { "IE": { "currency": "EUR", "country": "Ireland" } },
  { "IL": { "currency": "ILS", "country": "Israel" } },
  { "IT": { "currency": "EUR", "country": "Italy" } },
  { "IQ": { "currency": "AED", "country": "Iraq" } },
  { "JP": { "currency": "JPY", "country": "Japan" } },
  { "JO": { "currency": "AED", "country": "Jordan" } },
  { "KW": { "currency": "USD", "country": "Kuwait" } },
  { "KZ": { "currency": "KZT", "country": "Kazakhstan" } },
  { "KE": { "currency": "KES", "country": "Kenya" } },
  { "LA": { "currency": "LAK", "country": "Laos" } },
  { "LV": { "currency": "EUR", "country": "Latvia" } },
  { "LB": { "currency": "LBP", "country": "Lebanon" } },
  { "LY": { "currency": "GBP", "country": "Libya" } },
  { "LI": { "currency": "CHF", "country": "Liechtenstein" } },
  { "LT": { "currency": "EUR", "country": "Lithuania" } },
  { "LU": { "currency": "EUR", "country": "Luxembourg" } },
  { "MY": { "currency": "MYR", "country": "Malaysia" } },
  { "MT": { "currency": "EUR", "country": "Malta" } },
  { "MC": { "currency": "EUR", "country": "Monaco" } },
  { "MA": { "currency": "MAD", "country": "Morocco" } },
  { "MX": { "currency": "MXN", "country": "Mexico" } },
  { "MD": { "currency": "MDL", "country": "Moldova" } },
  { "MV": { "currency": "MVR", "country": "Maldives" } },
  { "NP": { "currency": "NPR", "country": "Nepal" } },
  { "NZ": { "currency": "NZD", "country": "New Zealand" } },
  { "MK": { "currency": "MKD", "country": "North Macedonia" } },
  { "NO": { "currency": "NOK", "country": "Norway" } },
  { "NG": { "currency": "NGN", "country": "Nigeria" } },
  { "OM": { "currency": "AED", "country": "Oman" } },
  { "PK": { "currency": "PKR", "country": "Pakistan" } },
  { "PS": { "currency": "ILS", "country": "Palestinian Territories" } },
  { "PH": { "currency": "PHP", "country": "Philippines" } },
  { "PL": { "currency": "EUR", "country": "Poland" } },
  { "PT": { "currency": "EUR", "country": "Portugal" } },
  { "PE": { "currency": "PEN", "country": "Peru" } },
  { "PY": { "currency": "PYG", "country": "Paraguay" } },
  { "PA": { "currency": "AED", "country": "Panama" } },
  { "QA": { "currency": "QAR", "country": "Qatar" } },
  { "ROW": { "currency": "GBP", "country": "Rest of the World" } },
  { "RO": { "currency": "EUR", "country": "Romania" } },
  { "SA": { "currency": "SAR", "country": "Saudi Arabia" } },
  { "RS": { "currency": "RSD", "country": "Serbia" } },
  { "SG": { "currency": "SGD", "country": "Singapore" } },
  { "SK": { "currency": "EUR", "country": "Slovakia" } },
  { "SI": { "currency": "EUR", "country": "Slovenia" } },
  { "ZA": { "currency": "AED", "country": "South Africa" } },
  { "ES": { "currency": "EUR", "country": "Spain" } },
  { "LK": { "currency": "LKR", "country": "Sri Lanka" } },
  { "SE": { "currency": "EUR", "country": "Sweden" } },
  { "CH": { "currency": "CHF", "country": "Switzerland" } },
  { "KR": { "currency": "KRW", "country": "South Korea" } },
  { "SC": { "currency": "AED", "country": "Seychelles" } },
  { "SN": { "currency": "AED", "country": "Senegal" } },
  { "TW": { "currency": "TWD", "country": "Taiwan" } },
  { "TH": { "currency": "THB", "country": "Thailand" } },
  { "TN": { "currency": "AED", "country": "Tunisia" } },
  { "TR": { "currency": "AED", "country": "Turkey" } },
  { "AE": { "currency": "AED", "country": "United Arab Emirates" } },
  { "VA": { "currency": "EUR", "country": "Vatican City" } },
  { "VN": { "currency": "VND", "country": "Vietnam" } },
  { "VE": { "currency": "AED", "country": "Venezuela" } },
  { "ZM": { "currency": "AED", "country": "Zambia" } },
  { "ZW": { "currency": "AED", "country": "Zimbabwe" } }
];  

function updateCountryFlag() {

 const countryFlags = {
   'AE': 'https://cdn.shopify.com/s/files/1/0282/6678/files/UAE.webp?v=1734340288',
   'QA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Qatar.webp?v=1734340288',
   'SA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Saudi_Arabia.webp?v=1734340288',
   'KW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Kuwait.webp?v=1734340288',
   'AU' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/ef8d72c4-fdf0-11ec-8b88-5254005a3760.png?v=1657253778',
   'IL' : 'https://cdn.shopify.com/s/files/1/0630/4261/7558/files/israel-29-12-2025.png?v=1767011031',
   'DE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Germany.png?v=1767591709',
   'NL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Netherlands.png?v=1767591743',
   'FR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/France.png?v=1767591743',
   'AL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Albania.png?v=1767591744',
   'DZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Algeria.png?v=1767591744',
   'AD' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Andorra.png?v=1767591744',
   'AM' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Armenia.png?v=1767591742',
   'AT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Austria.png?v=1767591743',
   'AZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Azerbaijan.png?v=1767591745',
   'AR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Argentina.png?v=1767597201',
   'BH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bahrain.png?v=1767591743',
   'BD' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bangladesh.png?v=1767591744',
   'BE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Belgium.png?v=1767591743',
   'BT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bhutan.png?v=1767591744',
   'BA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bosnia_and_Herzegovina.png?v=1767591743',
   'BR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Brazil.png?v=1767591744',
   'BN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Brunei.png?v=1767591744',
   'BG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bulgaria.png?v=1767591743',
   'BO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Bolivia.png?v=1767591744',
   'BF' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Burkina_Faso.png?v=1767597201',
   'KH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Cambodia.png?v=1767591744',
   'CN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/China.png?v=1767591744',
   'CO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Colombia.png?v=1767591743',
   'HR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Croatia.png?v=1767591743',
   'CY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Cyprus.png?v=1767591743',
   'CZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Czechia.png?v=1767591743',
   'CL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Chile.png?v=1767591743',
   'DK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Denmark.png?v=1767591743',
   'DO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Dominican_Republic.png?v=1767591744',
   'EE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Estonia.png?v=1767597201',
   'EG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Egypt.png?v=1767591744',
   'GQ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Equatorial_Guinea.png?v=1767591744',
   'FI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Finland.png?v=1767591742',
   'GE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Georgia.png?v=1767591743',
   'GI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Gibraltar.png?v=1767591744',
   'GR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Greece.png?v=1767591742',
   'GL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Greenland.png?v=1767591743',
   'GH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Ghana.png?v=1767591743',
   'HK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Hong_Kong.png?v=1767591743',
   'HU' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Hungary.png?v=1767597201',
   'IS' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Iceland.png?v=1767591743',
   'IN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/India.png?v=1767591744',
   'ID' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Indonesia.png?v=1767591743',
   'IE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Ireland.png?v=1767591744',
   'IT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Italy.png?v=1767591743',
   'IQ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Iraq.png?v=1767591744',
   'JP' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Japan.png?v=1767591743',
   'JO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Jordan.png?v=1767591743',
   'KZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Kazakhstan.png?v=1767591744',
   'LV' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Latvia.png?v=1767591743',
   'KE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Kenya.png?v=1767591744',
   'LA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Laos.png?v=1767591744',
   'LB' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Lebanon.png?v=1767591743',
   'LY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Libya.png?v=1767591744',
   'LI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Liechtenstein.png?v=1767591743',
   'LT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Lithuania.png?v=1767591744',
   'LU' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Luxembourg.png?v=1767594349',
   'MY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Malaysia.png?v=1767597201',
   'MT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Malta.png?v=1767594350',
   'MC' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Monaco.png?v=1767594350',
   'MA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Morocco.png?v=1767594349',
   'MX' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Mexico.png?v=1767594351',
   'MD' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Moldova.png?v=1767594350',
   'MV' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Maldives.png?v=1767594349',
   'NP' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Nepal.png?v=1767594350',
   'NZ' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/New_Zealand.png?v=1767594349',
   'MK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/North_Macedonia.png?v=1767594349',
   'NO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Norway.png?v=1767597200',
   'NG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Nigeria.png?v=1767594349',
   'OM' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Oman.png?v=1767594350',
   'PS' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Palestinian_Territories.png?v=1767594349',
   'PH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Philippines.png?v=1767594350',
   'PL' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Poland.png?v=1767594349',
   'PY' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Paraguay.png?v=1767594350',
   'PT' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Portugal.png?v=1767594350',
   'PE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Peru.png?v=1767594350',
   'PA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Panama.png?v=1767597201',
   'PK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Pakistan.png?v=1767594350',
   'ROW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Rest_of_the_World.png?v=1767596095',
   'RO' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Romania.png?v=1767596093',
   'RS' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Serbia.png?v=1767596094',
   'SG' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Singapore.png?v=1767596093',
   'SK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Slovakia.png?v=1767596093',
   'SI' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Slovenia.png?v=1767596093',
   'ZA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/South_Africa.png?v=1767596093',
   'ES' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Spain.png?v=1767597202',
   'LK' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Sri_Lanka.png?v=1767596094',
   'SE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Sweden.png?v=1767596093',
   'CH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Switzerland.png?v=1767596093',
   'KR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/South_Korea.png?v=1767596093',
   'SC' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Seychelles.png?v=1767596093',
   'SN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Senegal.png?v=1767596092',
   'TW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Taiwan.png?v=1767596093',
   'TH' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Thailand.png?v=1767596093',
   'TN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Tunisia.png?v=1767596092',
   'TR' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Turkey.png?v=1767597201',
   'VA' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Vatican_City.png?v=1767596094',
   'VN' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Vietnam.png?v=1767596093',
   'VE' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Venezuela.png?v=1767596093',
   'ZM' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Zambia.png?v=1767596094',
   'ZW' : 'https://cdn.shopify.com/s/files/1/0282/6678/files/Zimbabwe.png?v=1767596094',
    };

  /* Exact URL → Flag map */
  const urlFlags = {
    'https://me.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/0282/6678/files/UAE.webp?v=1734340288',
    'https://ca.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/0282/6678/files/ef904a58-fdf0-11ec-85db-525400a0165e.png?v=1657253779',
    'https://eu.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/0282/6678/files/eu-flag.png?v=1639998050',
    'https://us.manieredevoir.com/': 'https://cdn.shopify.com/s/files/1/1604/7647/files/186-united_states.png?v=1621320141',
    'https://uk.manieredevoir.com/': ' https://cdn.shopify.com/s/files/1/1604/7647/files/110-united_kingdom.png?v=1621320141'
    // add remaining URLs here (up to 16)
  };

  const img = document.querySelector('li.country img');
  if (!img) return;

  const countryFlag = document.cookie
    .split('; ')
    .find(c => c.startsWith('selectedCountry='))
    ?.split('=')[1];

    console.log("countryFlag", countryFlag)

  img.src =
    countryFlags[countryFlag] ||
    urlFlags[location.origin + '/'] ||
    img.src; // fallback = existing flag
}

function setStopRedirect() {
    if (new URLSearchParams(location.search).get('stop_redirect') === 'true') {
        document.cookie = "stop_redirect=true; max-age=" + 7*24*60*60 + "; path=/; domain=.manieredevoir.com; secure";
    }
}

function openCountrySelectorPopup() {
    setTimeout(function () {
            if (!getCookie("selectedCountry") && getCookie("show_redirection") !== "true" ) {
                $('.country-selector.custom-country-selector').addClass('active');
                $('body').addClass('no-scroll');
            }
    }, 4000);
}

function getActiveCountryOffers(countryCode) {
    const offersToShow = countryOffers.find(countryOffer => 
        countryOffer.countryCodes.includes(countryCode) || countryOffer.countryCodes.includes("ALL")
    );
    const offers = offersToShow ? offersToShow.offers : [];
    let htmlContent = '<ul>';
    offers.forEach(offerText => {
        htmlContent += `<li><span class="text-unset">${offerText}</span></li>`;
    });
    htmlContent += '</ul>';
    $(".country-selector-offer").html(htmlContent);
}

function getLanguagesByCountryCode(countryCode) {
    $('.language-select ul.language-select-option li').removeClass("active");
    const country = countriesLanguages.find(c => c.country_code.includes(countryCode));
    $(".language-select-option li").hide();
    if (country) {
        country.languages.forEach((language, index) => {
            const languageSelector = `.language-select-option li[value="${language.code}"]`;
            $(languageSelector).show();
            if (index === 0) {
            $(languageSelector).addClass('active');
            $(".language-select-value").html(language.name);
            }
        });
        $(".country-col.language").show();
    } else {
        $(".country-col.language").hide();
    }
}

function getCurrencyByCountryCode(countryCode, hideDropdown) {
    $('.price-select .small li').removeClass('active').hide();

    const result = countryCurrencyArray.filter(item => {
        const country = Object.keys(item)[0];
        return country === countryCode;
    });
    var currencyShow = $('.country-selector-select .country-selector-option li[data-code="' + countryCode + '"]').attr('data-currency');
    let setdefaultCurrency = false;

    if (result.length > 0) {
        const currency = result[0][countryCode].currency;
        const countryName = result[0][countryCode].country;
        const currencyElement = $('.price-select .small li[value="' + currency + '"]');
        if (currencyElement.length) {
            currencyElement.addClass('active');
            $('.price-select-value').html(currencyElement.html());
        } else {
            setdefaultCurrency = true;
        }
    } else {
        setdefaultCurrency = true;
    }
    if (setdefaultCurrency === true && currencyShow === "ME") {
        $('li[value="AED"]').addClass('active');
        $('.price-select-value').html($('li[value="AED"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "UK") {
        $('li[value="GBP"]').addClass('active');
        $('.price-select-value').html($('li[value="GBP"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "US") {
        $('li[value="USD"]').addClass('active');
        $('.price-select-value').html($('li[value="USD"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "EU") {
        $('li[value="EUR"]').addClass('active');
        $('.price-select-value').html($('li[value="EUR"]').html());
    } else if (setdefaultCurrency === true && currencyShow === "CA") {
        $('li[value="CAD"]').addClass('active');
        $('.price-select-value').html($('li[value="CAD"]').html());
    }

    $('.price-select .small li[data-code="' + currencyShow + '"]').show();
}

function setActiveCoutry(ShopifyCountry) {
    $('.custom-country-selector .country-selector-select li[data-code="' + ShopifyCountry + '"]').addClass('active');
    $('.country-selector-zone').val(
        $('.custom-country-selector .country-selector-select li[data-code="' + ShopifyCountry + '"]').html()
    );

    var autoHref = $('.country-selector-select .country-selector-option li.active').attr('data-href');
    if ($('.country-col.language').is(':visible')) {
        languageValue = "?"+$('.language-select-option li.active').attr('value')+"&";
    } else {
        var languageValue = '';
    }
    
    // alert('New URL 1=  '+ autoHref + languageValue);

    if (getCookie('selectedCountry')) {
        if (autoHref !== window.location.origin && !getCookie('stop_redirect')) {
            if (autoHref) {
                var redirection_url = autoHref + window.location.pathname + languageValue;
                window.location.href = redirection_url;
            } else {
                $('.country-selector-btn .country-selector-error').show();
            }
        }
    }
}

function updateCurrency(newCurrency) {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    updates: cart.items.reduce((acc, item) => {
                        acc[item.id] = item.quantity;
                        return acc;
                    }, {}),
                    currency: newCurrency
                }),
            })
            .then(response => response.json())
            .then(updatedCart => {
                document.cookie = "currency=; path=/; domain=.manieredevoir.com; expires=Thu, 01 Jan 1970 00:00:00 GMT; secure";

                location.reload();
            })
            .catch(error => console.error('Error updating cart:', error));
        })
        .catch(error => console.error('Error fetching cart:', error));
}

// Example of how to call the function to update the currency
 // Use the desired currency code, like 'USD', 'GBP', 'EUR'




$(document).ready(function() {

    if (!getCookie('stop_redirect')) {
        updateCountryFlag();
    }

    if(getCookie('selectedCountry')){
        var customerTargetCountry = getCookie('selectedCountry')
    }else{
        var customerTargetCountry = Shopify.country
    }

    if(getCookie('currency')){
        updateCurrency(getCookie('currency')); 
    }


    // if(customerTargetCountry == "QA"){
    //     $('body, html').addClass('glopal glopal-QA');
    // }
    // if(customerTargetCountry == "KW"){
    //     $('body, html').addClass('glopal glopal-KW');
    // }
    // if(customerTargetCountry == "AE"){
    //     $('body, html').addClass('glopal glopal-AE');
    // }
    // if(customerTargetCountry == "SA"){
    //     $('body, html').addClass('glopal glopal-SA');
    // }
    if(customerTargetCountry == "AU"){
        $('.show-only-au').show();
        $('.flag_uk').hide();
        var currentTitle = $('title').text();
        var updatedTitle = currentTitle.replace('Middle East', 'Australia');
        $('title').text(updatedTitle);
    }

    // updateCurrencyAndRemoveParams();


    setStopRedirect();
    getActiveCountryOffers(customerTargetCountry);
    getCurrencyByCountryCode(customerTargetCountry, true);
    setActiveCoutry(customerTargetCountry);
    getLanguagesByCountryCode(customerTargetCountry);
    openCountrySelectorPopup();
    
    // open popup
    $(document).on("click",'.header-style-one ul.header-right-icon li.country, .pass-right-icon',function(event) {
        event.preventDefault();
        $('.country-selector.custom-country-selector').addClass('active');
        $('body').addClass('no-scroll');
    });
    // close popup
    $(".custom-country-selector .country-selector-close, .country-selector .main-overlay").on("click", function () {
        $(".custom-country-selector.country-selector").removeClass("active");
        $('body').removeClass('no-scroll');
        setCookie("show_redirection", true, '365');
    });
    // toggle country list
    $(".country-selector-select-arrow").click(function(){
        $(".country-selector-select").toggleClass("active");
        $(".country-selector-option ").toggleClass("active");
    });
    // toggle price
    $(".price-select-arrow").click(function(){
        $(".price-select").toggleClass("active");
        $(".price-select .small").toggleClass("active");
    });
    // toggle language
    $(".language-select-arrow").click(function(){
        $(".language-select").toggleClass("active");
        $(".language-select-option").toggleClass("active");
    });
    // search country 
    $('.country-selector-zone').on("keyup", function () {
        var current_search = $(this).val().toLowerCase();
        $("ul.country-selector-option li").show();
        $("ul.country-selector-option li").each(function (index) {
            var search_match = $(this).attr("value").toLowerCase();
            if (search_match.indexOf(current_search) == 0) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
        if ($(this).val().length >= 1) {
            $('.country-selector-option .option-label').hide();
        } else {
            $(".country-selector-option .option-label").show();
        }
    });
    // open price list
    $('.price-select-value').on("click", function () {
        $(this).next(".price-select .small").addClass("active");
        $(this).parents('.price-select').addClass("active");
    });
    // select price li
    $('.custom-country-selector .country-selector-form .price-select li').on("click", function () {
        $('.custom-country-selector .country-selector-form .price-select li').removeClass('active');
        $(this).addClass('active');
        $('.custom-country-selector .country-selector-form .price-select-value').html($('.custom-country-selector .country-selector-form .price-select li[value=' + $(this).attr("value") + ']').html());
        $(this).parents("ul.small").removeClass('active');
        $(this).parents('.price-select').removeClass("active");
    });
    // select country li
    $('.custom-country-selector .country-selector-select li').on("click", function () {
        $('.custom-country-selector .country-selector-select li').removeClass("active");
        $(this).addClass("active");
        $('.country-selector-zone').val($(this).attr("value"));
        getActiveCountryOffers($(this).attr("data-code"));
        getCurrencyByCountryCode($(this).attr("data-code"));
        getLanguagesByCountryCode($(this).attr("data-code"));
        $(this).parents("ul").removeClass("active");
    });
    // open country list
    $('.country-selector-zone').on("click", function () {
        $(this).next("ul.country-selector-option").addClass("active");
        $(this).parents('.country-selector-select').addClass("active");
    });
    // open language list
    $('.language-select-value').on("click", function () {
        $(this).next("ul.language-select-option").addClass("active");
        $(this).parents('.language-select').addClass("active");
    });
    // select language li
    $('.language-select ul.language-select-option li').on("click", function () {
        $('.language-select ul.language-select-option li').removeClass("active");
        $(this).addClass("active");
        $(this).parents(".language-select").find(".language-select-value").html($(this).html());
        $(this).parents("ul.language-select-option").removeClass("active");
        $(this).parents('.language-select').removeClass("active");
    });
    // Update Button 
    $(".custom-country-selector button#change_country").on("click", function (event) {
        event.preventDefault();

        var dataHref = $('.country-selector-select .country-selector-option li.active').attr('data-href') + window.location.pathname;
        var selectedPrice = $('.price-select .small li.active').attr('value');
        var selectedCountry = $('.country-selector-select .country-selector-option li.active').attr('data-code')
        if ($('.country-col.language').is(':visible')) {
            var languageValue = "?"+$('.language-select-option li.active').attr('value')+"&";
        } else {
            var languageValue = '';
        }
        if (dataHref) {
            setCookie("show_redirection", true, '365');
            var redirection_url = dataHref + languageValue;
            document.cookie = "currency=" + selectedPrice + "; path=/; domain=.manieredevoir.com; secure";
            document.cookie = "selectedCountry=" + selectedCountry + "; expires=" + new Date(Date.now() + 365*24*60*60*1000).toUTCString() + "; path=/; domain=.manieredevoir.com; secure";
            
            // alert('New URL =  '+ redirection_url);

            // setTimeout(function() {
                window.location.href = redirection_url;
            // }, 1000);
            
        } else {
            $('.country-selector-btn .country-selector-error').show();
        }

    });
});


// close all list
$(document).on('click', function (event) {
    if (!$(event.target).closest('.price-select').length) {
        $(".price-select .small").removeClass("active");
        $('.price-select').removeClass("active");
    }
    if (!$(event.target).closest('.country-selector-select').length) {
        $(".country-selector-select").removeClass("active");
        $(".country-selector-option ").removeClass("active");
    }
    if (!$(event.target).closest('.language-select').length) {
        $(".language-select").removeClass("active");
        $(".language-select-option").removeClass("active");
    }
});

